import { Component, OnDestroy, OnInit } from '@angular/core';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade, RouterFacade } from '@classifieds-sell/state';
import { MotorsPageBase } from '../../motors-page-base';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';

@Component({
    selector: 'motors-summary-page',
    templateUrl: './motors-summary-page.component.html',
    styleUrls: ['./motors-summary-page.component.scss']
})
export class MotorsSummaryPageComponent
    extends MotorsPageBase
    implements OnInit, OnDestroy {

    displayClassifiedSection = false;
    displayAuctionSection = false;

    constructor(draftFacade: MotorsDraftFacade, routerFacade: RouterFacade) {
        super(StepIds.summary, draftFacade, routerFacade);
    }

    // TODO: a better way to handle per field formatting on the summary page.
    // to get rid of a lot of non required code for each fields formatting etc

    ngOnInit(): void {
        super.onInit();

        this.displayClassifiedSection = this.draftState.draftData.listingDetails.sellingType === SellingTypeEnum.classified;
        this.displayAuctionSection = this.draftState.draftData.listingDetails.sellingType === SellingTypeEnum.auction;
    }

    ngOnDestroy(): void {
        super.onDestroy();
    }
}
